import axios from "axios";
import React from "react";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { showToast } from "../../../utils/ToastHelper";
import { BASE_URL } from "../../Const/Url";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import down from "./../../../assets/Icon/down.svg";
import demoCsv from "./files/demo.csv";
import demoBulk from "./files/BulkDemoFile.xlsx";
import * as path from "./../../Routes/RoutePaths";
import swal from "sweetalert";
import Loader from "../../CustomCommons/Loader";
import ClockLoader from "react-spinners/ClockLoader";
import LoaderClock from "../../CustomCommons/LoaderClock";
import { logout_func3 } from "../../Const/logoutCommon";

const BulkImport = () => {
  const [fileName, setFileName] = useState(null);
  const [name, setName] = useState(null);
  const fileReader = new FileReader();
  const history = useHistory();
  const [isLoading, SetisLoading] = useState(false);
  const fileHandle = (e) => {
    setFileName(e.target.files[0]);
    setName(e.target.files[0].name);
    // console.log(e.target.files[0]);
  };
  const url = `${BASE_URL}api/v1/inventory/inventory/bulk-import/`;
  const [OnlogoutHide, setOnlogoutHide] = useState(0);

  const dataSubmit = () => {
    SetisLoading(true);
    const from = new FormData();
    const file = fileName;
    console.log(file);
    const reader = new FileReader();
    reader.onload = function (event) {
      const csvOutput = event.target.result;
      console.log(csvOutput);
      setFileName(csvOutput);
    };
    fileReader.readAsText(file);
    from.append("file", fileName);
    axios
      .post(url, from)
      .then((res) => {
        if (res.data.status) {
          showToast("success", "Products Added.");
          SetisLoading(false);
          history.push(path.product_list);
        }
      })
      .catch((err) => {
        //   const message = JSON.parse(err.request.response).message;
        //   const errorMsg = JSON.parse(err.request.response).errors;
        //   for (let value of Object.values(errorMsg)) {
        //     showToast("error", value[0]);
        //   }
        //   showToast("error", message);
        // });
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        const errorMsgForuser = errorMsg?.msg;
        console.log("errorMsg", errorMsg);
        var errors = "Please,Try again,after Solving this errors: \n \n ";
        for (let key in errorMsg) {
          errors += errorMsg[key];
          errors += "\n";
          errors += "\n";
        }
        swal({
          icon: "error",
          // text: `${errorMsg[key] === 'File is not a zip file' ? 'Only Exel file supported!' : errorMsg[key]}`
          text: errors,
        });
        SetisLoading(false);
        if (
          message === "Invalid token." ||
          JSON.parse(err?.request?.response)?.code === 401
        ) {
          logout_func3(history);
        }
      });
  };
  if (isLoading) {
    return <Loader />;
  }
  return (
    <div
      className="categorey-parent pd-right"
      style={{ height: "100vh", background: "#FAFAFA" }}
    >
      <div className="bg-white mb-3">
        <div
          className=""
          style={{ padding: "20px 35px ", border: "0.5px solid #E0E0E0" }}
        >
          <h3 className="head-tag" style={{ marginBottom: "20px" }}>
            Instruction
          </h3>
          <div className="inst mb-4" style={{ color: "#828282" }}>
            <p className="my-2">
              1. Download the format and fill it with proper data in XLSX format.
            </p>
            <p className="my-2">
              2. You can download the example file to understand how data must be filed.
            </p>
            <p className="my-2">
              3. Once you have downloaded and filed the file properly, please submit it.
            </p>
            <p className="my-2">
              4. After uploading the product you can edit it later.
            </p>
            <p className="my-2">
              5. Main category -- Home Decor = 0 and In Style = 1
            </p>
            <p className="my-2">
              6. Is New -- Yes = 1 & No = 0
            </p>
            <p className="my-2">
              7. If need further clarification, please contact the admin.
            </p>
          </div>
        </div>
      </div>

      {/* ======import=========== */}
      <div className="bg-white">
        {/* <form action="" onSubmit={(e) => dataSubmit(e)}> */}
        <div
          className="d-flex align-items-center justify-content-between side-pd"
          style={{ border: "0.5px solid #E0E0E0" }}
        >
          <h3
            className="h5-head"
            style={{ marginTop: "6px", marginLeft: "12px" }}
          >
            Import Product File
          </h3>
          <a
            href={`https://docs.google.com/spreadsheets/d/1K6kReiwXrSj1sbaKkOagA-_ObQpV2ihsOHK2T3z5Oz0/edit?usp=sharing`}
            target="_blank"
            // download
            style={{ border: "0", outline: "none" }}
            className="d-flex btn-text px-1 px-md-3 py-2  align-items-center bg-dark text-white"
          >
            <img className="me-1 format-img" src={down} alt="" /> Download
            Format
          </a>
        </div>
        <div className=" side-pd bord">
          {/* <p> *</p> */}
          <RequiredLabel text={"File"} />
          <div className="row">
            <div className="col-11 col-lg-4 col-md-6">
              <div
                className="w-100 browse-main d-flex align-items-center"
                style={{
                  height: "55px",
                  border: "1px solid #E0E0E0",
                  borderRadius: "7px",
                  overflowX: "hidden",
                }}
              >
                {name === "" || null ? (
                  <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                    No File Choosen
                  </p>
                ) : (
                  <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                    {" "}
                    {name}
                  </p>
                )}

                <div className="file-up">
                  <input accept=".xls, .xlsx" type="file" placeholder="select file" onChange={fileHandle} />
                  {/* <input accept={".csv"} type="file" onChange={fileHandle} /> */}
                  <p>Browse</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" side-pd bord">
          <button
            onClick={dataSubmit}
            className="save-btn me-2 mt-2"
            style={{ background: "#000", color: "white" }}
          >
            Save
          </button>
          {/* <input
              type="submit"
              value={"Save"}
              className="save-btn me-2 mt-2"
              style={{ background: "#000", color: "white" }}
            /> */}
        </div>
        {/* </form> */}
      </div>
    </div>
  );
};

export default BulkImport;
